import { useQuery } from "react-query";
import { fetchLanguages } from "../../api/fetchLanguages";
import { Language } from "../../model/Language";
import LanguageCacheName from "../../utils/LanguageCacheName";

const EMPTY_LANGUAGES : Language[] = [];

export const useLanguages = () => {
  const { data, isLoading, isError } = useQuery({
    queryKey: [LanguageCacheName.getLanguageList()],
    queryFn: fetchLanguages,
  });
  const languages = data ?? EMPTY_LANGUAGES;

  return { languages, isLoading, isError };
};
